/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable no-multi-str */
import { showSpinner, changeDateByDays, openAreYouSurePopup } from '../helpers';
import { showTaskDetails, updateEmployeesCounter } from './shared';
import { updateUrl } from './draw_employee_planner';
import { showFlashMessage } from '../flash';

$(document).ready(() => {
  $(document).on('click', '.colored_task_mobile', function () {
    const expandableArea = $(this).parent().find('.expandable_area');
    if (expandableArea.is(':visible')) {
      expandableArea.hide();
      expandableArea.find('.planned_employees').html('');
    } else {
      showTaskDetails(expandableArea);
    }
  });

  $(document).on('click', '.assigned_to_task_employee .convert_to_actual_task', function (e) {
    const assignedToTaskEmployee = $(this).closest('.assigned_to_task_employee');
    const task = assignedToTaskEmployee.closest('.task_mobile');
    const expandableArea = $(this).closest('.expandable_area');
    e.stopPropagation();
    const taskId = assignedToTaskEmployee.data('taskId');
    const taskClass = assignedToTaskEmployee.data('taskClass');
    if (assignedToTaskEmployee.data('taskClass') === 'Task') {
      $.ajax({
        url: 'planned_employee_days/destroy_task',
        type: 'DELETE',
        data: { task_id: taskId, task_class: taskClass },
        beforeSend() { showSpinner(); },
        complete() { $('.spinner').hide(); },
        success(data) {
          if (data.status === 'ok') {
            showTaskDetails(expandableArea);
            updateEmployeesCounter(task, expandableArea);
          }
        },
      });
    } else {
      const data = {
        employee_id: assignedToTaskEmployee.data('employeeId'),
        task_id: taskId,
        task_class: taskClass,
        project_id: task.data('projectId'),
        supervisor_id: task.data('supervisorId'),
        date: task.data('date'),
      };
      $.ajax({
        url: 'planned_employee_days/create_actual_task_from_planned',
        type: 'POST',
        data,
        beforeSend() { showSpinner(); },
        complete() { $('.spinner').hide(); },
        success(data) {
          if (data.status === 'ok') {
            showTaskDetails(expandableArea);
          }
        },
      });
    }
  });

  $(document).on('click', '.task_mobile .assigned_to_task_employee', function (e) {
    e.stopPropagation();
    const task = $(this);
    const duration = task.find('.task_tracked_time_span').text();
    const dataAttributes = $(this).data();
    const data = {
      task_id: dataAttributes.taskId,
      task_class: dataAttributes.taskClass,
    };
    if ($(this).next().hasClass('employee_details_container')) {
      $(this).next().remove();
    } else {
      $.ajax({
        url: '/planned_employee_days/task_comments',
        type: 'GET',
        data,
        beforeSend() { showSpinner(); },
        complete() { $('.spinner').hide(); },
        success(data) {
          const employeeDetailsContainerHtml = "<div class='hidden employee_details_container'> \
            <div class='comments_container'> \
              <b>Comments: </b> \
              <div class='comments_feed'></div> \
              <input type='text' id='comment_input_box' placeholder='Enter comment'> \
              <a class='nav-button send_comment'>Send</a> \
            </div> \
          </div>";
          const employeeDetailsContainer = $(employeeDetailsContainerHtml);
          employeeDetailsContainer.find('.comments_feed').html(data);
          if (task.find('.formatted_tracked_time').length) {
            addSectionWithTaskDuration(employeeDetailsContainer, duration);
          }
          task.after(employeeDetailsContainer);
          employeeDetailsContainer.show();
        },
      });
    }

    function addSectionWithTaskDuration(employeeDetailsContainer, duration) {
      const taskDurationInfoHtml = `<div class='task_duration_info'>  \
           <b>Duration: </b> \
           <input type='text' class='tracked_time_input' placeholder='0.0' value=${duration}> \
           <a class='nav-button save_task_duration hidden'>Save</a> \
        </div>`;
      employeeDetailsContainer.prepend(taskDurationInfoHtml);
    }
  });

  $(document).on('click', '.task_duration_info .tracked_time_input', function () {
    $(this).siblings('.save_task_duration').show();
  });

  $(document).on('click', '.task_mobile .expandable_area, .task_mobile .comments_container', (e) => {
    e.stopPropagation();
  });

  $(document).on('click', '.comments_container .send_comment', function () {
    const employeeDetailsContainer = $(this).closest('.employee_details_container');
    const task = employeeDetailsContainer.siblings('.assigned_to_task_employee');
    const commentInputBox = employeeDetailsContainer.find('#comment_input_box');
    const message = commentInputBox.val();
    const dataAttributes = task.data();
    const data = {
      task_id: dataAttributes.taskId,
      task_class: dataAttributes.taskClass,
      message,
    };
    $.ajax({
      url: 'planned_employee_days/leave_task_comment',
      type: 'POST',
      data,
      beforeSend() { showSpinner(); },
      complete() { $('.spinner').hide(); },
      success(data) {
        commentInputBox.val('');
        const commentsFeed = employeeDetailsContainer.find('.comments_feed');
        commentsFeed.html(data);
        const commentsCount = commentsFeed.find('div.panel').length;
        task.find('.comments_count').text(commentsCount);
      },
    });
  });

  $(document).on('click', '.expandable_area .delete_task', function (e) {
    e.stopPropagation();
    const task = $(this).closest('.task_mobile');
    const plannedTaskId = task.find('#planned_task_id').val();
    if (!plannedTaskId) { return; }
    const data = {
      task_id: plannedTaskId,
      task_class: 'PlannedTask',
    };
    const deleteTaskCallback = function () {
      $.ajax({
        url: 'planned_employee_days/destroy_task',
        type: 'DELETE',
        data,
        beforeSend() { showSpinner(); },
        complete() { $('.spinner').hide(); },
        success(data) {
          if (data.status === 'ok') {
            task.remove();
          }
        },
      });
    };
    openAreYouSurePopup(deleteTaskCallback);
  });

  $(document).on('click', '.expandable_area .complete_task', function (e) {
    e.stopPropagation();
    const task = $(this).closest('.task_mobile');
    const expandableArea = $(this).closest('.expandable_area');
    const completeButton = $(this);
    const status = task.data('completedActualTasks');
    const data = {
      date: task.data('date'),
      competency_id: task.data('competencyId'),
      supervisor_id: task.data('supervisorId'),
      task_id: task.data('taskId'),
      task_class: task.data('taskClass'),
      completed: status,
    };
    $.ajax({
      url: 'planned_employee_days/toggle_status_for_actual_tasks',
      type: 'PUT',
      data,
      beforeSend() { showSpinner(); },
      complete() { $('.spinner').hide(); },
      success(data) {
        if (data.status === 'ok') {
          showTaskDetails(expandableArea);
          completeButton.toggleClass('base-green');
          const actualTasksAreCompleted = completeButton.hasClass('base-green');
          task.data('completedActualTasks', actualTasksAreCompleted);
          const coloredTask = task.find('.colored_task_mobile');
          if (actualTasksAreCompleted) {
            coloredTask.removeClass('incompleted_task');
            coloredTask.addClass('completed_task');
          } else {
            coloredTask.removeClass('completed_task');
            coloredTask.addClass('incompleted_task');
          }
        }
      },
    });
  });

  $(document).on('click', '.prev_week_mobile, .next_week_mobile', function () {
    const weekButton = $(this);
    const date = weekButton.data('date');
    const mode = weekButton.data('mode');
    let dateDelta = 0;
    let week = '';
    if (weekButton.attr('class') === 'prev_week_mobile') {
      dateDelta = -7;
      week = 'previous';
    } else {
      dateDelta = 7;
      week = 'next';
    }

    const newDate = changeDateByDays(date, dateDelta);
    const formattedDate = $.datepicker.formatDate('dd/mm/yy', newDate);
    const daysCount = $('.week_day_mobile').length;
    $.ajax({
      url: mode === 'tasks' ? '/planned_employee_days/task_planner.js' : '/planned_employee_days.js',
      data: { date: formattedDate, mode, week },
      success(data) {
        const url = `date=${formattedDate}&mode=${mode}&days_count=${daysCount}`;
        updateUrl(url);
      },
      error() {
        showFlashMessage('Something went wrong.');
      },
    });
  });
});
